export default "__VITE_ASSET__DBZb46v8__"